export const loader_action = "loader_action/change";

export const preloaderShow = (message='데이터처리중입니다.') => ({
    type: loader_action,
    payload: {
        display: true,
        message: message
    }
});

export const preloaderHide = () => ({
    type: loader_action,
    payload: {
        display: false,
        message: ''
    }
});


// WEBPACK FOOTER //
// ./src/libs/redux/actions/preloader.js